import { render, staticRenderFns } from "./quest-import.vue?vue&type=template&id=1c520228&scoped=true"
import script from "./quest-import.vue?vue&type=script&lang=js"
export * from "./quest-import.vue?vue&type=script&lang=js"
import style0 from "./quest-import.vue?vue&type=style&index=0&id=1c520228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c520228",
  null
  
)

export default component.exports